/**
 * LOTO-Typen (Freischaltplan & Freischaltbereiche)
 *
 * Ein Freischaltplan (loto_plans) ist ein Bild (Vogelperspektive der Anlage,
 * vertraulich → privater Storage-Bucket 'loto-plans'), auf dem Admin/Mod
 * Rechteck-Bereiche (loto_areas) einzeichnen. Freischaltaufgaben werden über
 * tasks.loto_area_id einem Bereich zugeordnet.
 */

export interface LotoPlan {
    id: number,
    /** Maschine/Standort, gruppiert mehrere Ebenen (z.B. "PM3"). Leer = eigenständiger Plan. */
    group_name: string,
    /** Ebenen-/Planname (z.B. "8,5 m") */
    name: string,
    description: string,
    image_path: string | null,     // Pfad im privaten Bucket 'loto-plans'
    /** Reihenfolge der Ebene innerhalb ihrer Maschine */
    sort_order: number,
    created_by?: string | null,
    created_at?: string,
    updated_at?: string,
}

export interface LotoArea {
    id: number,
    plan_id: number,
    name: string,
    color: string,
    // Relative Koordinaten (0..1), skalieren mit der Bildgröße
    x: number,
    y: number,
    w: number,
    h: number,
    created_at?: string,
    updated_at?: string,
}

export interface LotoAreaWithStats extends LotoArea {
    task_count: number,
    task_state_counts: Record<string, number>,
}

/** Relativer Bildausschnitt (0..1) beim Zuschneiden eines Plans */
export interface CropRect {
    x: number,
    y: number,
    w: number,
    h: number,
}

/** Sammelgruppe für Pläne ohne Maschinen-Zuordnung */
export const UNGROUPED_PLAN_LABEL = 'Allgemein';

/** Maschine eines Plans – Pläne ohne group_name landen in der Sammelgruppe */
export function planGroupLabel(plan?: LotoPlan | null): string {
    return plan?.group_name?.trim() || UNGROUPED_PLAN_LABEL;
}

/** Vollständige Bezeichnung „Maschine – Ebene“ (ohne Maschine nur der Planname) */
export function planFullName(plan?: LotoPlan | null): string {
    if (!plan) return '';
    const group = plan.group_name?.trim();
    return group ? `${group} – ${plan.name}` : plan.name;
}

export const DEFAULT_LOTO_AREA_COLOR = '#2196F3';

/** Preset-Farben für Bereiche (gut unterscheidbar auf hellem Planhintergrund) */
export const LOTO_AREA_COLORS = [
    '#2196F3', // Blau
    '#CE0058', // Pro-Rot
    '#4CAF50', // Grün
    '#FF9800', // Orange
    '#9C27B0', // Lila
    '#00BCD4', // Cyan
    '#795548', // Braun
    '#607D8B', // Blaugrau
];
